<div class="container-detail">

  <!-- DESCRIPCIÓN -->
  <div class="d-flex flex-column flex-md-row">
    <div class="d-flex flex-column py-4 py-lg-5 px-3 px-lg-5">
      <h4><strong>Descripción del proyecto</strong></h4>

      <div class="fs-14" [innerHtml]="devDescription"></div>

      <!-- SECCIÓN DE FOLLETO DE INVERSIÓN - SOLO FUNCIÓN SI TIENE EL LINK DEL FOLLETO  -->
      <div class="mt-4 mb-3">
        <h4><strong>Materiales de inversión</strong></h4>
        <p>Consulta los detalles de la oportunidad de inversión:</p>
        <button class="d-block mt-4" mat-button *ngIf="dev?.devInfoDetail?.brochureInversionLink" (click)="openLink(dev?.devInfoDetail?.brochureInversionLink)">Descargar folleto de inversión</button>
        <button class="d-block mt-4" mat-button *ngIf="dev?.devInfoDetail?.termSheet" (click)="openLink(dev?.devInfoDetail?.termSheet)">Descargar prospecto de inversión</button>
        <button class="d-block mt-4" mat-button *ngIf="dev?.devInfoDetail?.tour3D" (click)="openLink(dev?.devInfoDetail?.tour3D)">Recorrido Virtual 360</button>
        <button class="d-block mt-4" mat-button *ngIf="dev?.devInfoDetail?.modelInvest" (click)="openLink(dev?.devInfoDetail?.modelInvest)">Visita la página de Modelo de inversión</button>
        <button class="d-block mt-4" mat-button *ngIf="dev?.devInfoDetail?.investmentProspectus" (click)="openLink(dev?.devInfoDetail?.investmentProspectus)">Descargar term sheet del proyecto</button>

      </div>
      <!-- END | FOLLETO SECCIÓN -->

    </div>

    <div class="img-container">
      <img [src]="dev?.images?.[0] || dev?.gallery?.[0]" alt="">
    </div>
  </div>
  <!-- END | DESCRIPCIÓN -->

  <!-- CONTENEDOR - OPORTUNIDAD DE INVERSIÓN -->
  <div class="bg" *ngIf="dev?.devInfoDetail?.investmentOpportunity">
    <h3 class="fw-bold ms-3 fs-20">Oportunidad de inversión</h3>
    <ul>
      <li class="ms-lg-3 my-3 list-style-none" *ngFor="let item of dev?.devInfoDetail?.investmentOpportunity">
        <div [innerHTML]="item"></div>
      </li>
    </ul>
    <div class="table-responsive" *ngIf="dev?.devInfoDetail?.monthsEstimateResidential">
      <table class="table border table-adjust">
        <thead>
          <tr class="text-center">
            <th class="border bg-secondary">Escenario</th>
            <th class="border bg-secondary">Duración estimada<br> (Meses)</th>
            <th class="border bg-secondary">Rendimiento anual</th>
            <th class="border bg-secondary">Rendimiento total</th>
          </tr>
        </thead>
        <tbody>
          <!-- Optimista -->
          <tr class="text-center">
            <th class="border bg-primary" scope="row">Optimista</th>
            <td class="bg-primary">{{ datosProcesados[0]?.duracion }}</td>
            <td class="bg-primary">{{ datosProcesados[0]?.rendimientoAnual }} %</td>
            <td class="bg-primary">{{ datosProcesados[0]?.rendimientoTotal }} %</td>
          </tr>
          <!-- Estimado -->
          <ng-container *ngFor="let item of datosProcesados; let i = index" [ngSwitch]="i">
            <tr class="text-center" *ngSwitchCase="1">
              <th class="border bg-secondary align-middle" rowspan="3" scope="row">Estimado</th>
              <td class="border bg-secondary">{{ item?.duracion }} </td>
              <td class="border bg-secondary">{{ item?.rendimientoAnual }} %</td>
              <td class="border bg-secondary">{{ item?.rendimientoTotal }} %</td>
            </tr>
            <tr class="text-center" *ngSwitchCase="2">
              <td class="border bg-secondary">{{ item?.duracion }}</td>
              <td class="border bg-secondary">{{ item?.rendimientoAnual }} %</td>
              <td class="border bg-secondary">{{ item?.rendimientoTotal }} %</td>
            </tr>
            <tr class="text-center" *ngSwitchCase="3">
              <td class="border bg-secondary">{{ item?.duracion }}</td>
              <td class="border bg-secondary">{{ item?.rendimientoAnual }} %</td>
              <td class="border bg-secondary">{{ item?.rendimientoTotal }} %</td>
            </tr>
          </ng-container>
          <!-- Pesimista -->
          <tr class="text-center">
            <th class="border bg-primary" scope="row">Mínimo</th>
            <td class="bg-primary">{{ datosProcesados[4]?.duracion }}</td>
            <td class="bg-primary">{{ datosProcesados[4]?.rendimientoAnual }} %</td>
            <td class="bg-primary">{{ datosProcesados[4]?.rendimientoTotal }} %</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
  <!-- END | OPORTUNIDAD DE INVERSIÓN-->


  <!-- CONTENEDOR - PREGUNTAS-->

  <div class="row m-auto col-11 mb-5" *ngIf="dev?.devInfoDetail?.questions">
    <h3 class="fw-bold fs-24 mt-5">Preguntas frecuentes</h3>
    <div class="col-12  main-card-cont col-lg-6 my-4" *ngFor="let item of dev?.devInfoDetail?.questions; let i = index;">
      <div class="">
        <div class="title p-3 d-flex align-items-center justify-content-between">
          <div [innerHTML]="getTitleQuestion(item)"></div>
          <fa-icon [icon]="!collapseStates[i] ? iconShow : iconHide" class="cr-pointer" (click)="toggleCollapse(i)"></fa-icon>
        </div>
      </div>
      <div class="description p-3" *ngIf="collapseStates[i]">
        <div [innerHTML]="getDescriptionQuestion(item)"></div>
      </div>
    </div>
  </div>
  <!-- END | PREGUNTAS -->

  <!-- CONTENEDOR CARACTERÍSTICAS -->
  <div class="bg" *ngIf="dev?.features?.project || dev?.features?.rooms">
    <div class="row justify-content-around">
      <!-- PROYECTO -->
      <div class="col-12 col-md-6" *ngIf="dev?.features?.project">
        <div class="feature">
          <h5 class="ms-2"><strong>Características del proyecto</strong></h5>
          <div class="d-flex">
            <ul class="me-3">
              <li *ngFor="let f of dev?.features?.project">{{ f }}</li>
            </ul>
            <img class="ms-auto mt-auto me-4" src="https://static.monific.com/assets/assets-app/img/building.svg" alt="">
          </div>
        </div>
      </div>
      <!-- HABITACIÓN -->
      <div class="col-12 col-md-6" *ngIf="dev?.features?.rooms">
        <div class="feature">
          <h5 class="ms-2"><strong>Características por habitación</strong></h5>
          <div class="d-flex">
            <ul class="me-3">
              <li *ngFor="let f of dev?.features?.rooms">{{ f }}</li>
            </ul>
            <img class="ms-auto mt-auto me-4" src="https://static.monific.com/assets/assets-app/img/couch.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center justify-content-md-end">
      <button class="btn-space" mat-button *ngIf="dev?.devInfoDetail?.tour3D" (click)="openLink(dev?.devInfoDetail?.tour3D)">Hacer recorrido 3D</button>
    </div>
  </div>
  <!-- END | CARACTERÍSTICAS -->

  <!-- AMENIDADES -->
  <div *ngIf="amenities?.length">
     <h4 class="ms-5 mt-5 mb-4"><strong>Amenidades</strong></h4>
     <div class="row mx-0 mb-4">
        <div class="col-md-3 col-lg-2 mb-3 d-none d-md-block" *ngFor="let am of amenities">
           <div class="amenity">
              <fa-icon class="fs-20 cl-neutral-3" [icon]="icons[am.icon]"></fa-icon>
              <p>{{ am.title }}</p>
            </div>
         </div>
    <div class="col-12 col-sm-6 d-flex justify-content-center flex-column d-md-none mb-3" *ngFor="let am of amenities">
       <div class="d-flex ms-4">
          <fa-icon class="fs-14 cl-neutral-3 me-3 my-auto" [icon]="icons[am.icon] || faStar"></fa-icon>
          <p class="mb-0 my-auto">{{ am.title }}</p>
      </div>
   </div>
</div>
</div>
  <!-- END | AMENIDADES -->

  <!-- GALLERY -->
  <h4 class="ms-5 mt-5 mb-4"><strong>Fotos</strong></h4>
<div class="W-100">
   <gallery gallerize [items]="images"></gallery>
</div>
  <!-- END | GALLERY -->

</div>
